export default {
  setUser(state, userData) {
    state.token = userData.token;
    state.refreshToken = userData.refreshToken;
    state.userID = userData.userID;
    state.firstName = userData.firstName;
    state.lastName = userData.lastName;
    state.userName = userData.userName;
    state.lastLoginDateTime = userData.lastLoginDateTime;
    state.requireChangePassword = userData.requireChangePassword;
    state.isPartTime = userData.isPartTime;
    state.personID = userData.personID;
    state.hasUnseenMessage = userData.hasUnseenMessage;
  },
  changeClient(state, userData) {
    state.firstName = userData.firstName;
    state.lastName = userData.lastName;
    state.isPartTime = userData.isPartTime;
    state.personID = userData.personID;
    state.hasUnseenMessage = userData.hasUnseenMessage;
  },
  changeUnseenMessage(state, data) {
    state.hasUnseenMessage = data;
  },
  async setRefreshTokenData(state, data) {
    state.token = data.token;
    state.refreshToken = data.refreshToken;
  },
  async setUnseenNotifications(state, data) {
    state.userUnseenNotifications = data;
  },
  async setUserPartTime(state, data) {
    state.isPartTime = data;
  },
};
